import { client } from '../client';

export const confirmMedia = async (conversationSid: string, mediaId: string): Promise<Response> => {
  const { data } = await client.patch<Response>(`/conversations/${conversationSid}/media/${mediaId}/confirm`, {});

  return data;
};
